import { Tag } from '@loadsmart/loadsmart-ui'
import { Grid, Stack, Typography } from '@mui/material'
import { TrafficResponseWrapper } from 'common/types/kraken-core/TrafficVolume'
import MessageStatusTag from 'pages/Messages/common/MessageStatusTag'
import { useEffect, useState } from 'react'

export interface MessageTrafficVolumeRateProps {
  traffic?: TrafficResponseWrapper
}

interface MessageTrafficVolumeRateState {
  status: string
  rate: number
}

export default function MessageTrafficVolumeRate(props: MessageTrafficVolumeRateProps) {
  const [traffic, setTraffic] = useState<Array<MessageTrafficVolumeRateState>>([])

  useEffect(() => {
    if (!props.traffic || !props.traffic.traffic || !props.traffic.traffic.count) {
      setTraffic([])
      return
    }
    const totalCount = props.traffic.traffic.count
    const countByStatus = props.traffic.traffic.buckets.reduce((acc, bucket) => {
      Object.keys(bucket.per_agg).forEach(status => {
        if (!acc[status]) {
          acc[status] = 0
        }
        acc[status] += bucket.per_agg[status]
      })
      return acc
    }, {} as Record<string, number>)

    const trafficArray: Array<MessageTrafficVolumeRateState> = Object.entries(countByStatus).map(
      ([status, rate]) => ({
        status,
        rate: (rate / totalCount) * 100,
      })
    )

    setTraffic(trafficArray)
  }, [props.traffic])

  return (
    <Grid container spacing={2}>
      <Grid item key={'total'}>
        <Stack spacing={1} justifyContent={'center'} alignItems={'center'}>
          <Tag variant="outlined">Total Count</Tag>
          <Typography variant="h1" fontWeight={'bold'}>
            {props.traffic?.traffic.count || 0}
          </Typography>
        </Stack>
      </Grid>
      {traffic.map((item, index) => (
        <Grid item key={index}>
          <Stack spacing={1} justifyContent={'center'} alignItems={'center'}>
            <MessageStatusTag status={item.status} />
            <Typography variant="h1" fontWeight={'bold'}>
              {item.rate.toFixed(2)}%
            </Typography>
          </Stack>
        </Grid>
      ))}
    </Grid>
  )
}
